import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent {
  @Input() title: string;
  @Input() subtitle?: string;
  @Input() cancelLabel?: string;
  @Input() validateLabel?: string;
  @Input() question?: string | undefined;
  @Input() requiredQuestion = false;
  @Input() answers?: { code: string; label: string }[] | undefined;
  @Output() cancel = new EventEmitter();
  @Output() validate = new EventEmitter<string | undefined>();
  questionInvalid: false;
  answer: string | undefined;

  constructor(private bsModalRef: BsModalRef) {
    // do nothing
  }

  hideModal() {
    this.bsModalRef.hide();
  }

  enableValidate() {
    if (this.question && this.requiredQuestion) {
      return this.answer && this.answer.length > 0;
    } else {
      return true;
    }
  }
}
